import { render, staticRenderFns } from "./ProjectQuotes.vue?vue&type=template&id=4bc0e8e8&scoped=true&"
import script from "./ProjectQuotes.vue?vue&type=script&lang=js&"
export * from "./ProjectQuotes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuotes.vue?vue&type=style&index=0&id=4bc0e8e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0e8e8",
  null
  
)

export default component.exports